import React, { useMemo, Fragment, useState, useRef } from "react";
import ArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Combobox, Transition } from "@headlessui/react";
import SystemLabel from "../../components/SystemLabel";
import useOnClickOutside from "../../hooks/onClickOutside";

const includes = (source, target) => source?.toLowerCase()?.includes(target.toLowerCase());
const filterDeleted = (qo) => !qo.status || (qo.status && qo.status != "deleted");
const sort = (a, b) => a.sortOrder - b.sortOrder;

export const OptionSelector = (props) => {
  const containerRef = useRef(null);
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
    const { settings, environment, activePersonNo, question, handleChange, options, orders, valid = undefined } = props;
  const { showPlaceholder = false, placeholderText = null } = settings;

  useOnClickOutside([{ current: containerRef.current }], () => setOpen(false), open);

  const questionOptions = useMemo(
    () =>
      options?.map(({ questionOptionLanguage, ...rest }) => ({
        ...rest,
        label: questionOptionLanguage?.find(({ languageCode }) => languageCode === environment.lang)?.label,
      })),
    [question, environment, options]
  );

  const filteredOptions = useMemo(() => {
    if (!query) return questionOptions?.filter(filterDeleted).sort(sort);
    return questionOptions?.filter((qo) => filterDeleted(qo) && includes(qo.label, query)).sort(sort);
  }, [query, questionOptions]);

  const selectedOption = useMemo(() => {
    return questionOptions?.find(({ questionOptionId: _questionOptionId }) => _questionOptionId === orders[activePersonNo]?.answer?.find((a) => a.questionId == question.questionId)?.answerRow[0]?.questionOptionId);
  }, [orders, activePersonNo, questionOptions]);

  return (
    <div className="select-wrap selector" ref={containerRef}>
      <Combobox
        value={selectedOption}
        onChange={(option) => {
          handleChange(true, option.questionOptionId);
          setOpen(false);
        }}
      >
        <div className="autocomplete">
          <div className="input-base">
            <Combobox.Input
              onClick={() => setOpen((prev) => !prev)}
              onChange={(event) => setQuery(event.target.value)}
              displayValue={(prop) => prop?.label}
                          className="selector-menu form-control"
                          style={{ border: valid === false ? "1px solid #d53443" : undefined }}
              placeholder={showPlaceholder ? placeholderText : ""}
            />
            <Combobox.Button onClick={() => setOpen((prev) => !prev)}>
              <ArrowDownIcon />
            </Combobox.Button>
          </div>
          <Transition show={open} as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" afterLeave={() => setQuery("")}>
            <Combobox.Options>
              {filteredOptions?.length === 0 ? (
                <div style={{ padding: 10 }}>
                  <SystemLabel name="NoResult" />
                </div>
              ) : (
                filteredOptions?.map((option) => (
                  <Combobox.Option key={option.questionOptionId} value={option} as={Fragment}>
                    {({ selected }) => <li className={selected ? "selected" : ""}>{option?.label}</li>}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
};
